import { useToast } from "@chakra-ui/react";
import { QueryClient, useInfiniteQuery } from "react-query";
import { toastGenerator } from "../..";
import { storage } from "../plugins/secret";

// * Handle Query Error
const HandleQueryError = (err) => {
  const toast = useToast();
  if (storage.getToken()) {
    toast(toastGenerator({ status: "error", message: "Server Error, Please try again later" }));
  }
};

// * Build Default Query Client Options
const defaultQueryClientOptions = {
  queries: {
    onError: HandleQueryError,
    retry: 3,
    staleTime: 1,
    cacheTime: 300000,
    refetchOnWindowFocus: false,
  },
  mutations: {
    onError: HandleQueryError,
  },
};

// * Build Query Client
export const queryClient = new QueryClient({
  defaultOptions: defaultQueryClientOptions,
});

// * Build Infinite Query
export function useInfiniteQueryFn(key, queryFn, config) {
  return useInfiniteQuery(key, queryFn, {
    getNextPageParam: (lastPage) => lastPage.pagination && (lastPage.pagination.rowsPerPage * lastPage.pagination.page < lastPage.pagination.total ? lastPage.pagination.page + 1 : false),
    ...config,
  });
}
